import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { isNullOrUndefined } from 'src/app/services/utils';
import { COMMON_CONSTANTS, MANAGE_LINE_CONST, TRANSACTION_HISTORY_CONSTANTS } from '../../../common/core/common.constants';
import { HttpCacheService } from 'src/app/services/http-cache.service';
import { LoaderService } from 'src/app/services/loader.service';
import { ManageLineService } from 'src/app/services/manage-line.service';
import {OktaAuthorizationService} from 'src/app/services/okta-auth-service';
import { UtilsService } from 'src/app/services/utils.service';
import { WindowServiceService } from 'src/app/services/window-service.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {

  returnURI: string;
  authoringContentData: any;
  loginPage = true;
  shouldShow: any;
  logoutbx: any;
  isAuthenticated = false;
  userName: any;
  userInfo: any = [];
  userOktaName: any;
  userOktaFullName: any;

  constructor(
    private _cacheSvc: HttpCacheService,
    public utilsSvc: UtilsService,
    public oktaAuth: OktaAuthorizationService,
    private router: Router,
    public manageLineService: ManageLineService,
    private _loaderSvc: LoaderService,
    private _windowService: WindowServiceService
  ) {}

  ngOnInit() {
    this.manageLineService.settingHeaderValue.subscribe((flagValue) => {
      if (!isNullOrUndefined(flagValue)) {
        this.loginPage = flagValue;
        this.logoutbx = false;
      }
      this.authoringContentData = this.utilsSvc.getContentDataFromSession();
      this.userInfo = !isNullOrUndefined(sessionStorage.getItem(MANAGE_LINE_CONST.AUTHENTICATION_INFO)) ?
        sessionStorage.getItem(MANAGE_LINE_CONST.AUTHENTICATION_INFO) : '';
    });
    if (this._windowService.location.pathname.indexOf(COMMON_CONSTANTS.LOGIN_PATH) === COMMON_CONSTANTS.DIGITS.MINUS_ONE) {
      this.loginPage = false;
    }
    this.returnURI = this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.RETURN_URL_SSP);
    this.oktaAuth.notifyUserInfo.subscribe((userInfo: any) => {
      this.isAuthenticated = true;
      this.userName = userInfo.firstName + ' ' + userInfo.lastName;
      this.authoringContentData = this.utilsSvc.getContentDataFromSession();
    });
    this.userOktaName = sessionStorage.getItem(COMMON_CONSTANTS.OKTA_USER_PROFILE);
    if (!isNullOrUndefined(this.userOktaName)) {
      this.userOktaFullName = JSON.parse(this.userOktaName);
      this.userName = this.userOktaFullName.firstName + ' ' + this.userOktaFullName.lastName;
      this.isAuthenticated = true;
    }

  }
  onClickMngAcc() {
    this.manageLineService.clickManageAccount.next(true);
  }
  logout() {
    this.loginPage = true;
    this.router.navigate([TRANSACTION_HISTORY_CONSTANTS.REDIRECT_TO_LOGIN_PAGE]);
    this._loaderSvc.stop();
    this._cacheSvc.clearSessionStorage();
    history.pushState(null, null, location.href);
    window.onpopstate = function() {
        history.go(COMMON_CONSTANTS.DIGITS.ONE);
    };

  }

  logOutFromOkta() {
    this.oktaAuth.logOutFromOkta();
  }
}
